import React, { Component } from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { modal } from "../modal";
import { AreaChecker } from "../../pages/area/AreaChecker";
import { SearchCondition } from "../../pages/area/SearchCondition";

export const modal_area_change = props => {
  const pref = 1;
  const cities = [];
  const onUpdateValue = () => {};
  return (
    <div className="modal_area_change modal_base">
      <div className="back link" onClick={() => modal.closeModal()}>
        戻る
      </div>
      <div className="title">条件を変更する</div>
      <AreaChecker
        pref={pref}
        cities={cities}
        onChangeValue={value => {
          onUpdateValue({ city: value });
        }}
      />
      <SearchCondition {...{ type: TYPE_SP }} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_area_change.jsx